import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AppModal, OrangeComboBanner } from '@beef/elk-common';
import { selectIsOrangeComboError, selectIsOrangeComboPending, selectModalComboInfo } from "../../store/selectors";
import { fubMetricSideMenu } from "../../utils/metric";
import { selectAccountType } from "../Container/ConnectionBlock/store/selectors";
export var _OrangeComboButton = function _OrangeComboButton(_ref) {
  var _comboInfo$button2;
  var comboInfo = _ref.comboInfo,
    accountType = _ref.accountType,
    _ref$isPending = _ref.isPending,
    isPending = _ref$isPending === void 0 ? false : _ref$isPending,
    _ref$showSkeleton = _ref.showSkeleton,
    showSkeleton = _ref$showSkeleton === void 0 ? false : _ref$showSkeleton,
    isError = _ref.isError;
  var _comboInfo$button = comboInfo.button,
    title = _comboInfo$button.title,
    logos = _comboInfo$button.logos,
    action = _comboInfo$button.action,
    url = _comboInfo$button.url;
  var _comboInfo$modal = comboInfo.modal,
    modalTitle = _comboInfo$modal.modalTitle,
    subtitle = _comboInfo$modal.subtitle,
    qrCode = _comboInfo$modal.qrCode,
    text = _comboInfo$modal.text,
    image = _comboInfo$modal.image;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenModal = _useState2[0],
    setModalState = _useState2[1];
  var handleOrangeComboClick = function handleOrangeComboClick() {
    fubMetricSideMenu.handleOrangeComboClick(accountType || '');
    setModalState(true);
  };
  useEffect(function () {
    if (isOpenModal) {
      fubMetricSideMenu.handleOrangeComboModalView(accountType || '');
    }
  }, [isOpenModal]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OrangeComboBanner, {
    action: action,
    isMobile: true,
    isPending: isPending,
    logos: logos,
    onClick: handleOrangeComboClick,
    shouldRender: (!!(comboInfo !== null && comboInfo !== void 0 && (_comboInfo$button2 = comboInfo.button) !== null && _comboInfo$button2 !== void 0 && _comboInfo$button2.title) || isPending) && !isError,
    showSkeleton: showSkeleton,
    title: title,
    url: url,
    "data-t-id": "components-OrangeCombo"
  }), /*#__PURE__*/React.createElement(AppModal, {
    image: image,
    isOpen: isOpenModal,
    onClose: function onClose() {
      return setModalState(false);
    },
    portalProps: {
      'data-portal': 'app-modal'
    },
    qrCode: qrCode,
    subtitle: subtitle,
    text: text,
    title: modalTitle
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var _comboInfo$button3, _selectAccountType;
  var comboInfo = selectModalComboInfo(state);
  var isPending = selectIsOrangeComboPending(state);
  var isError = selectIsOrangeComboError(state);
  return {
    comboInfo: comboInfo,
    shouldRender: !!(comboInfo !== null && comboInfo !== void 0 && (_comboInfo$button3 = comboInfo.button) !== null && _comboInfo$button3 !== void 0 && _comboInfo$button3.title) || isPending,
    accountType: (_selectAccountType = selectAccountType(state)) === null || _selectAccountType === void 0 ? void 0 : _selectAccountType.toLocaleLowerCase(),
    isPending: isPending,
    isError: isError
  };
};
var connector = connect(mapStateToProps);
export var OrangeComboButton = connector(_OrangeComboButton);